var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 0.5,
    y1: -2.18557e-8,
    x2: 0.500002,
    y2: 45,
    stroke: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 4.37114e-8,
    y1: 44.5,
    x2: 45,
    y2: 44.5,
    stroke: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleLine);
export default __webpack_public_path__ + "static/media/rectangle-line.15031b00d11cdd5bc5b9636632510ca4.svg";
export { ForwardRef as ReactComponent };